export default {
  state: () => ({
    version: 'unknown',
    buildDate: 'unknown',
    messages: {},
    colorScheme: 'light'
  }),
  getters: {
    buildInfo: (state) => ({ version: state.version, buildDate: state.buildDate }),
    sseMessages: (state) => {
      return state.messages
    },
    colorScheme: (state) => {
      return state.colorScheme
    }
  },
  mutations: {
    setBuildInfo (state, payload) {
      state.version = payload.version
      state.buildDate = payload.buildDate
    },
    addGlobalWarning (state, payload) {
      const { code, severity, message } = payload

      if (!Object.hasOwn(state.messages, code)) {
        state.messages[code] = {
          id: code,
          type: severity,
          text: message
        }
      }
    },
    removeGlobalWarning (state, payload) {
      delete state.messages[payload]
    },
    setColorScheme (state, colorScheme) {
      state.colorScheme = colorScheme
    }
  },
  actions: {
    initialize ({ commit }) {
      commit('setBuildInfo', { version: APP_VERSION, buildDate: APP_BUILD_DATE })
      import.meta.env.DEV && console.log('initialized store – app')
    }
  }
}
